export var NoOfSharesHistoryType;
(function (NoOfSharesHistoryType) {
    NoOfSharesHistoryType["Initial"] = "INITIAL";
    NoOfSharesHistoryType["ShareSplit"] = "SHARE_SPLIT";
    NoOfSharesHistoryType["Exit"] = "EXIT";
    NoOfSharesHistoryType["Transfer"] = "INVESTMENT_TRANSFER";
})(NoOfSharesHistoryType || (NoOfSharesHistoryType = {}));
//# sourceMappingURL=index.js.map